import { render, staticRenderFns } from "./AnalysisResultLite.vue?vue&type=template&id=0570fb36&scoped=true"
import script from "./AnalysisResultLite.vue?vue&type=script&lang=js"
export * from "./AnalysisResultLite.vue?vue&type=script&lang=js"
import style0 from "./AnalysisResultLite.vue?vue&type=style&index=0&id=0570fb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0570fb36",
  null
  
)

export default component.exports